import React, { useState } from 'react';
import { MaximusPoolWithValue } from '../../../maximus/lib/types';
import { ZERO } from '../../../maximus/utils';
import ToggleButton from '../../../components/ToggleButton';
import FarmDexSelect from './FarmDexSelect';
import FarmSortSelect from './FarmSortSelect';
import FarmSearchBox from './FarmSearchBox';
import FarmCard from './FarmCard';

interface FarmListProps {
  pools: MaximusPoolWithValue[];
}

const FarmList: React.FC<FarmListProps> = ({ pools }) => {
  const [activeFilter, setActiveFilter] = useState([
    'deposited',
    'lp',
    'single',
  ]);

  const [selectedDexOption, setSelectedDexOption] = useState(0);
  const [selectedSortOption, setSelectedSortOption] = useState(0);
  const [seachText, setSeachText] = useState('');

  let filtredPools = pools.sort((a, b) => {
    if (selectedSortOption === 1) {
      return a.apy! < b.apy! ? 1 : -1;
    } else if (selectedSortOption === 2) {
      return b.tvl.comparedTo(a.tvl);
    } else return 0;
  });

  filtredPools = filtredPools.sort((a, b) => {
    const a_dep = (!a.closed && a.portfolio.gt(ZERO));
    const b_dep = (!b.closed && b.portfolio.gt(ZERO));
    if ((a_dep && !b_dep)){
      return -1;
    }else if( !a_dep  && b_dep){
      return 1;
    }else{
      return 0;
    }
  })

  filtredPools = filtredPools.filter((pool) => {
    switch (selectedDexOption) {
      case 1:
        return pool.swap.toLowerCase().includes('pangolin');
      case 2:
        return pool.swap.toLowerCase().includes('traderjoe');
      case 3:
        return pool.swap.toLowerCase().includes('lydia');
      default:
        return pool.swap.toLowerCase().includes('');
    }
  });

  filtredPools = filtredPools.filter((pool) => {
    const searchPool = `${pool.name} ${pool.earn} ${pool.deposit} ${pool.description} ${pool.swap} ${pool.type}`;
    return searchPool.toLowerCase().includes(seachText.toLowerCase());
  });
  
  filtredPools = filtredPools.filter((pool) => {
    return activeFilter.length === 3
      ? true
      : (activeFilter.includes('deposited') && !pool.portfolio.lte(ZERO)) ||
          (activeFilter.includes('lp') && pool.tokens.length !== 1) ||
          (activeFilter.includes('single') && pool.tokens.length === 1);
  });

  const handleFilterButtonChange = (item: any) => {
    const _activeFilter = [...activeFilter];

    if (_activeFilter.includes(item)) {
      setActiveFilter([..._activeFilter.filter((_item) => _item !== item)]);
    } else {
      setActiveFilter([...activeFilter, item]);
    }
  };

  // @ts-ignore
  return (
    <div className="farms-list-wrapper">
      <div className="farms-list">
        <div className="filter-bar">
          <div className="filter-buttons">
            <ToggleButton
              isActive={activeFilter.includes('deposited')}
              text="Deposited"
              onClick={() => handleFilterButtonChange('deposited')}
            />
            <ToggleButton
              isActive={activeFilter.includes('lp')}
              text="LP"
              onClick={() => handleFilterButtonChange('lp')}
            />
            <ToggleButton
              isActive={activeFilter.includes('single')}
              text="Single"
              onClick={() => handleFilterButtonChange('single')}
            />
          </div>
          <div className="filter-select">
            <FarmDexSelect
              onChange={(e: { value: React.SetStateAction<number> }) =>
                setSelectedDexOption(e?.value!)
              }
            />
          </div>
        </div>
        <div className="section">
          <div className="title-bar">
            <div className="title">
              <span>{`Pools (${filtredPools.length})`}</span>
            </div>
            <div className="title-bar-tools">
              <FarmSortSelect
                onChange={(e: { value: React.SetStateAction<number> }) =>
                  setSelectedSortOption(e?.value!)
                }
              />
              <FarmSearchBox
                handleChange={(e: {
                  target: { value: React.SetStateAction<string> };
                }) => setSeachText(e.target.value!)}
              />
            </div>
          </div>
          {filtredPools.length > 0 ? (
            filtredPools.map((pool, index) => {
              return (
                <div key={`farms-row-${index}`} className="row">
                  <FarmCard pool={pool} />
                </div>
              );
            })
          ) : (
            <span className="not-found-message">No pools to list...</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FarmList;
